const optionExists = (opts, value) =>
  !!value && opts.some(
    o => (o.value || "").toLowerCase() === value.toLowerCase()
  );

// Options reflect the real ATS AttachmentCategories. The configured fallback ("Other") is always offered
// as a safety net even when it isn't a real category, but the default ("Roi-AI") is NOT injected — it only
// appears when it genuinely exists in the categories. Exception: when there are no categories at all
// (null/empty, e.g. an ATS with no contact attachment categories), inject both default and fallback so the
// field stays usable. #11998
export const buildSaveResponseDocumentTypeOptions = (categories = [], defaults = {}) => {
  const { defaultCategory, fallbackCategory } = defaults || {};
  const list = categories || [];

  if (list.length === 0) {
    const opts = [];
    if (defaultCategory) {
      opts.push({ value: defaultCategory, label: defaultCategory });
    }
    if (fallbackCategory && !optionExists(opts, fallbackCategory)) {
      opts.push({ value: fallbackCategory, label: fallbackCategory });
    }
    return opts;
  }

  const opts = list.map(c => ({ value: c.category, label: c.category }));
  if (fallbackCategory && !optionExists(opts, fallbackCategory)) {
    opts.push({ value: fallbackCategory, label: fallbackCategory });
  }
  return opts;
};

// No (or invalid) savedValue: pick the default ("Roi-AI") if it's an available option, else the fallback
// ("Other") if available, else the first available option. #11998
export const resolveDefaultSaveResponseDocumentType = (categories = [], defaults = {}) => {
  const { defaultCategory, fallbackCategory } = defaults || {};
  const opts = buildSaveResponseDocumentTypeOptions(categories, defaults);
  if (defaultCategory && optionExists(opts, defaultCategory)) {
    return defaultCategory;
  }
  if (fallbackCategory && optionExists(opts, fallbackCategory)) {
    return fallbackCategory;
  }
  return opts.length ? opts[0].value : null;
};

// Cascade: savedValue (if still a selectable option) → defaultCategory ("Roi-AI") → fallbackCategory ("Other").
// Mirrors BE AttachmentCategoryHelper.ResolveAttachmentCategoryAsync behaviour.
// Validate against the options actually offered (categories + default/fallback), not just `categories`.
// On the contact form editor `categories` can be empty, leaving only the pushed default/fallback options; checking
// `categories` alone there rejected every selection and always collapsed to fallbackCategory ("Other"). #11998
export const resolveSaveResponseDocumentType = (savedValue, categories = [], defaults = {}) => {
  const opts = buildSaveResponseDocumentTypeOptions(categories, defaults);
  if (savedValue && optionExists(opts, savedValue)) {
    return savedValue;
  }
  return resolveDefaultSaveResponseDocumentType(categories, defaults);
};
